// extracted by mini-css-extract-plugin
export default {"hamburgerButton":"SmallScreenHeaderNav-module__hamburgerButton___vZlzz"};